import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazySocialAccount = loadable(() => import(/* webpackChunkName: "content/createwedding-social-account" */ './SocialAccount'), 'SocialAccount');
